module.exports = __webpack_public_path__ + "static/media/fee_dasa.0b0f8933.pdf";